import React from 'react';
import './App.css';
import 'tachyons';
import myself from './Styling/myself.jpg';

const Content =() => {
  return (
    
     <div id="Content" className="Content parallax">
      <h1 className="content-heading1 f1">About Me</h1>
      <div className="dt mw9 center pv4 pv5-m pv4-ns">
        <img src={myself} alt="self" className="br-100 h5 w5 dib" />
          <article className="dtc v-mid pl3">
            <p className="lh-copy mw7 f4">I am a Frontend Web Developer, with a particular flair for HTML and CSS. Reactjs 
                is a new found hobby and I am eagerly learning this new language. 
                I am from South Africa, living in a very small town. 
                </p>
                <p className="lh-copy mw7 f4">
                I have been studying coding for the past two years, and I am eager to help you find 
                your web solution. My Frontend skills all include HTML5, CSS3, Javascript and Reactjs. 
                If there is a need for a different language, I will step up to the challange.
            </p>
            <p className="lh-copy mw7 f4">
                I am also a hobbyist writer as well. I have written two ebooks. One book telling the story of a 
                young girl and her small group of friends navigating high school. With a few unfortunate teenage situations. 
                My second book is on a young secret author trying to solve the mystery of why the town teen football star got himself into an 
                accident. Meeting a few strange people along the way of solving this mystery, 
                she is determined to find out what happend, before her secret is revealed.  
            </p>
          </article>
      </div>
    </div>
   
  );
}

export default Content;